import useFeatureFlags from 'hooks/useFeatureFlags'

const useNeedSeverityEnabled = (): boolean => {
  const { data: flags, isLoading } = useFeatureFlags({
    flagNames: ['mods_needs_resident_profile', 'mods_needs_severity']
  })

  // Severity only exists on the v6 resident-needs API, so it needs both flags.
  return (
    !isLoading &&
    !!(
      flags.mods_needs_resident_profile?.enabled &&
      flags.mods_needs_severity?.enabled
    )
  )
}

export default useNeedSeverityEnabled
